export default __webpack_public_path__ + "static/media/hero1.69399a08.jpg";